import React from "react";

const Card = ({ icon, title, points }) => {
  return (
    <div className="bg-[#F8FAFF] rounded-lg p-6 flex-1 max-w-xs">
      <div className="w-12 h-12 mb-4 flex items-center justify-center rounded-md bg-[#F0F5FF]">
        {icon}
      </div>
      <h3 className="font-bold text-lg mb-3">{title}</h3>
      <ul className="text-slate-700 text-md space-y-2 list-disc list-inside">
        {points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

const cards = [
  {
    title: "AI-First Design",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v18m9-9H3" />
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeWidth={2}
          fill="none"
        />
      </svg>
    ),
    points: [
      "Voice and text interaction for natural communication",
      "Intelligent navigation that learns user preferences",
      "Predictive insights for better decision-making",
    ],
  },
  {
    title: "Seamless Integration",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    ),
    points: [
      "All-in-one platform for every educational need",
      "Compatible with existing school systems",
      "Easy implementation and onboarding",
    ],
  },
  {
    title: "Proven Results",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11 17l-5-5m0 0l5-5m-5 5h12"
        />
      </svg>
    ),
    points: [
      "Increased student engagement",
      "Improved learning outcomes",
      "Reduced administrative workload",
      "Enhanced parent involvement",
    ],
  },
];

const WhyChooseCard = () => {
  return (
    <div className="bg-gradient-to-r from-[#e9efff] via-[#f7f5f7] to-[#f7f5f7] min-h-screen ">
<main className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-12">
  <h2 className="text-center text-3xl font-extrabold mb-8">
    Why Choose PSTVue?
  </h2>
  <div className="flex flex-col sm:flex-row justify-center gap-12 max-w-5xl mx-auto">
    {cards.map((card) => (
      <Card
        key={card.title}
        icon={card.icon}
        title={card.title}
        points={card.points}
      />
    ))}
  </div>
</main>

    </div>
  );
};
export default WhyChooseCard;
